// extracted by css-extract-rspack-plugin
export default {"orderButtons":"orderButtons-rukyTu","button":"button-eZRiGC"};